import { render } from "./1Society.vue?vue&type=template&id=880b21d0&scoped=true"
import script from "./1Society.vue?vue&type=script&lang=js"
export * from "./1Society.vue?vue&type=script&lang=js"

import "./1Society.vue?vue&type=style&index=0&id=880b21d0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-880b21d0"

export default script